async function postAvailabilityAPI(data) {
  return await window.fetch('/webapi/public/timeslots/public/api/v1/timeslots/availability', {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
    },
  });
}

export default postAvailabilityAPI;
